// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageBoxContent-root-1yh2s htmlContent-root-1db2D typography-bodyCopy-3JspD"};